const SEND_REQUEST = 'contact/SEND_REQUEST';

export default {
  SEND_REQUEST,
};
